
<div class="modal-dialog" style="max-width: 800px;">
  <div class="modal-content">
    <div class="modal-body">
      <div class="standalone-step-name-container mb-3">
        <role-block [roles]="targetStep?.roles" [extraCss]="&quot;z20&quot;"></role-block><span style="z-index: 19">{{ targetStep?.readableStepName }}</span>
      </div>
      <p><span [hidden]="!correctRole">You have access to this step, but you may need to hand this step over to another role.</span><span [hidden]="correctRole">You do not have access to this step, and may hand this step over to another role.</span><br><span>If you choose to, the following users will be notified:</span></p>
      <ul style="list-style-type: none; padding-left: 60px;">
        <li *ngFor="let user of users; first as first; last as last;" style="position: relative; height: 26px;">
          <role-block [roles]="user?.roles" [stacking]="true" [extraCss]="(first &amp;&amp; !last ? &quot;first&quot; : &quot;&quot;) + &quot; &quot; + (last &amp;&amp; !first ? &quot;last&quot; : &quot;&quot;) + &quot; &quot; + (!first &amp;&amp; !last ? &quot;middle&quot; : &quot;&quot;)" style="position: absolute; top: -10px; left: -80px;"></role-block><span>{{ user.name }} &lt;{{ user.emailAddress }}&gt;</span>
        </li>
      </ul>
    </div>
    <div class="modal-footer">
      <button class="btn btn-outline-secondary" type="button" (click)="close()">Don't Notify</button>
      <button class="btn btn-primary" type="button" (click)="notify()">Send Notification</button>
    </div>
  </div>
</div>